export enum ResetPasswordResponseEnum {
    SUCCESS = 'success',
    NOT_FOUND = 'not_found',
    ERROR = 'error',
}

export interface IResetPasswordResponse {
    status: ResetPasswordResponseEnum;
    errorCode?: string;
}
